import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {FormBuilder, FormControl, Validators} from '@angular/forms';
import {MatDialogRef} from '@angular/material/dialog';
import {QuestionsService} from '../../../services/questions.service';

@Component({
  selector: 'app-create-question-categories',
  templateUrl: './create-question-categories.component.html',
  styleUrls: ['./create-question-categories.component.scss']
})
export class CreateQuestionCategoriesComponent implements OnInit {

  questionCategoriesCreateForm = this.formBuilder.group({
    description: ['', Validators.required],
  });

  get descriptionControl(): FormControl {
    return this.questionCategoriesCreateForm.get('description') as FormControl;
  }

  @Output()
  createEvent: EventEmitter<void> = new EventEmitter<void>();

  constructor(private dialogRef: MatDialogRef<CreateQuestionCategoriesComponent>,
              private readonly formBuilder: FormBuilder,
              private readonly questionsService: QuestionsService) { }

  ngOnInit(): void {
  }

  sendCreationRequest(): void {
    this.questionsService.createQuestionCategory(this.descriptionControl.value).subscribe(
      () => {
        this.createEvent.emit();
        this.closeDialog();
      },
      () => {
        this.closeDialog();
      }
    );
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

}
